import React from 'react';
import { Checkbox } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useBranches } from './useBranches';
import { CustomCheckbox } from '../../../components/CustomControls/CustomCheckbox';

export const VisitBranchSelector = ({ protocolId, selectedBranchIds = [], onChange, required }) => {
    const { t } = useTranslation();
    const [branches, isLoading] = useBranches(protocolId);

    if (!branches.length && !isLoading) return null;

    const isNoRama = selectedBranchIds.length === 0;

    const handleToggleBranch = (branchId) => {
        const updated = selectedBranchIds.includes(branchId)
            ? selectedBranchIds.filter(id => id !== branchId)
            : [...selectedBranchIds, branchId];
        onChange(updated);
    };

    const handleNoRama = () => {
        onChange([]);
    };

    return (
        <div className="visit-branch-selector">
            <label className="control-label">
                {t('protocols.branches.visitBranches')}
                {required && <span className="text-danger"> *</span>}
            </label>

            <CustomCheckbox
                name="NoRama"
                checked={isNoRama}
                label={t('protocols.branches.sinRama')}
                onChange={handleNoRama}
            />

            {branches.map(branch => (
                <CustomCheckbox
                    key={branch.id}
                    name={branch.id}
                    checked={selectedBranchIds.includes(branch.id)}
                    onChange={() => handleToggleBranch(branch.id)}
                    label={branch.name}
                />
            ))}
        </div>
    );
};
